export function on(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
export function off(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
} // eslint-disable-next-line @typescript-eslint/no-explicit-any

export var hasOwnProperty = function hasOwnProperty(obj, property) {
  return Object.prototype.hasOwnProperty.call(obj, property);
};
export var yieldTrue = function yieldTrue() {
  return true;
};
export var yieldFalse = function yieldFalse() {
  return false;
};
export var basicDepsComparator = function basicDepsComparator(d1, d2) {
  if (d1 === d2) return true;
  if (d1.length !== d2.length) return false;

  for (var i = 0; i < d1.length; i++) {
    if (d1[i] !== d2[i]) {
      return false;
    }
  }

  return true;
};